// extracted by mini-css-extract-plugin
export default {"Header":"TopCitiesCard_Header__cIACL"};